/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

// Import jQuery for DOM manipulation
import $ from 'jquery';
import { closeModal } from '../../utils/modal-helpers';


const initializeProjectAttributes = require('./components/project_attributes');

window.Projects = {
  _defaultLatLng: { lat: 24.466667, lng: 54.366669 },

  _onLocationChange() {
    let latLng;
    const place = this.address.getPlace();
    if (latLng = this._getCoordinatesFromInput(place.name)) {
      return this._getReverseGeocodingData(latLng);
    } else {
      this._setLocationValues(place);
      this._setCityAndStateValues(place);
      this._setDistrictValue(place);
      this.marker.setPosition(place.geometry.location);
      return this.map.setCenter(place.geometry.location);
    }
  },

  _onLocationMarkerChange() {
    const latLng = this.marker.getPosition();
    return this.geocoder.geocode({ latLng }, responses => {
      if (responses && (responses.length > 0)) {
        $('#project_location').val(responses[0].formatted_address);
        const cityAndStateAddress = this._findCityAndStateAddress(responses);
        this._setLocationValues(responses[0]);
        if (cityAndStateAddress) {
          this._setCityAndStateValues(cityAndStateAddress);
        }
        return this._setDistrictValue(responses[0]);
      }
    });
  },

  _setLocationValues(address) {
    $('#project_location_attributes_latitude').val(address.geometry.location.lat());
    $('#project_location_attributes_longitude').val(address.geometry.location.lng());
    $('#project_location_attributes_country_name').val(this._findAddressComponent(address, "country"));
    $('#project_location_attributes_street_line_1').val(this._findAddressComponent(address, "route"));
    return $('#project_location_attributes_street_line_2').val(this._findAddressComponent(address, "street_number"));
  },

  _setCityAndStateValues(address) {
    $('#project_location_attributes_city_name').val(this._findAddressComponent(address, "locality"));
    return $('#project_location_attributes_state_name').val(this._findAddressComponent(address, "administrative_area_level_1"));
  },

  _setDistrictValue(address) {
    return $('#project_location_attributes_district').val(this._findAddressComponent(address, "sublocality"));
  },

  _findCityAndStateAddress(addresses) {
    for (let address of Array.from(addresses)) {
      if (address.types[0] === 'locality') {
        return address;
      }
    }
  },

  _findAddressComponent(address, name) {
    if (address) {
      const result = _.find(address.address_components, obj => obj.types.indexOf(name) >= 0);
      if (result) { return result.long_name; } else { return null; }
    } else {
      return null;
    }
  },

  _getCoordinatesFromInput(latLngStr) {
    if (!latLngStr) { return; }

    const latLng = latLngStr.split(',', 2);
    if (latLng.length === 2) {
      return { lat: parseFloat(latLng[0]), lng: parseFloat(latLng[1]) };
    } else {
      return;
    }
  },

  _getReverseGeocodingData(lat, lng) {
    const latLng = new google.maps.LatLng(lat, lng);
    return this.geocoder.geocode({ 'latLng': latLng }, (responses, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        this._setLocationValues(responses[0]);
        this._setCityAndStateValues(responses[0]);
        this._setDistrictValue(responses[0]);
        this.marker.setPosition(responses[0].geometry.location);
        this.map.setCenter(responses[0].geometry.location);
        return $('#project_location').val(responses[0].formatted_address);
      }
    });
  },

  _camelCase(string) {
    return string.replace(/_\w/g, m => m[1].toUpperCase());
  },

  _sortBy(e) {
    e.preventDefault();
    const $target = $(e.target);
    $target.parents('ul').find('a').removeClass('selected');
    $target.addClass('selected');
    $target.parents('ul').parent().find('span').text($target.html());
    const sortColumn = this._camelCase($target.data().sortColumn);

    const compareFunction = function (a, b) {
      const aDataSortValue = a.dataset[sortColumn];
      const bDataSortValue = b.dataset[sortColumn];

      if (aDataSortValue && bDataSortValue) {
        const aDateValue = parseInt(aDataSortValue);
        const bDateValue = parseInt(bDataSortValue);

        if (aDateValue && bDateValue) {
          return bDateValue - aDateValue;
        } else {
          return aDataSortValue.localeCompare(bDataSortValue);
        }
      } else {
        if (aDataSortValue) {
          return -1;
        } else if (bDataSortValue) {
          return 1;
        } else {
          return 0;
        }
      }
    };

    const $objectsColumns = $('.objects-columns');
    return _.each($objectsColumns, function (objectsColumn) {
      const $objects = $(objectsColumn).find('.objects');
      return $objects.find('.object').sort(compareFunction).appendTo($objects);
    });
  },

  _isFileSizeValid(file) {
    return file.size <= 5242880;
  },

  _onPhotoInputChange(e) {
    e.preventDefault();
    if (($('#uploaded_photos li.product-photo').length + $(e.target.files).length) > 5) {
      $('#exceed_maximum_number_of_photos').foundation('reveal', 'open');
      return;
    }

    $(e.target.files).each((key, value) => {
      const parentDiv = $(e.target).parent('.project_photos_image');
      if (this._isFileSizeValid(value)) {
        let height;
        parentDiv.removeClass('error');
        parentDiv.find('small.error').remove();
        const $el = $(e.target).closest('li');
        if (key === 0) {
          $('.photo-container .add-files', $el).remove();
          $('.uploaded-photo-placeholder', $el).siblings('.edit-controls').removeClass('hide');
          $('.uploaded-photo-placeholder', $el).closest('li').attr('data-filename', value.name);
          $('.uploaded-photo-placeholder', $el).closest('li').addClass('product-photo');
          $('.uploaded-photo-placeholder', $el).siblings('.edit-controls').find('.main-photo-r').val(value.name);

          height = $('.uploaded-photo-placeholder', $el).closest('.photo-container').width();
          loadImage(value, (function (img) {
            $('.uploaded-photo-placeholder', $el).replaceWith(img);
          })
          );

          $('li.product-photo .photo-container', $el).css('background', 'white');
          return setTimeout((function () {
            $('li.product-photo .photo-container img', $el).css('max-height', height);
            return $('li.product-photo .photo-container img', $el).show();
          }), 50);
        } else {
          const class_name = Math.random().toString(36).substring(7);
          const new_li =
            '<li class="product-photo photo-uploading-placeholder-' + class_name + '" data-filename="' + value.name + `">
<div class="photo-container" style="background:white; height:` + height + `px">
<div class="img-placeholder"></div>
<div class="edit-controls">
<input class="main-photo-r" id="mainphoto_" name="mainphoto" type="radio" value="` + value.name + `">
<label class="product-main-photo">` + I18n.t('v4.projects.photo_attributes.main') + `</label>
<a class="set-as-cover-btn">
<span class="text">` + I18n.t('v4.projects.photo_attributes.set_as_main') + `</span>
</a>
<div class="edit">
<a class="delete-product-photo" href="#"><i class="pti pt-delete"></i>
</a>
</div>
</div>
</div>
</li>`;

          $('#uploaded_photos').append(new_li);

          loadImage(value, (function (img) {
            $('.photo-uploading-placeholder-' + class_name).find('.img-placeholder').replaceWith(img);
          })
          );

          $('li.product-photo .photo-container img').css('max-height', height);
          $('li.product-photo .photo-container img').show();

          return setTimeout((function () {
            $('li.product-photo .photo-container img').css('max-height', height);
            $('li.product-photo .photo-container img').show();

            return $.each($('li.product-photo .photo-container img'), function (key, value) {
              if (parseInt($(value).attr('width')) > parseInt($(value).attr('height'))) {
                return $(value).css('width', height);
              }
            });
          }), 200);
        }
      } else {
        e.target.value = null;
        parentDiv.addClass('error');
        let errorMsg = parentDiv.find('small.error');
        if (errorMsg.length === 0) {
          errorMsg = '<small class="error">' + I18n.t('v4.projects.form.validation.max_file_size_exceeded') + '</small>';
          return parentDiv.append(errorMsg);
        }
      }
    }
    );
    if (($('#uploaded_photos small.error').length === 0) && ($('#uploaded_photos li.product-photo').length < 5)) {
      setTimeout((function () {
        $('.dropper a.add_nested_fields').click();
        const height = $('#uploaded_photos li .photo-container').width();
        $('li.product-photo .photo-container img').css('max-height', height);
        $('li.product-photo .photo-container').height(height);
        return $('#uploaded_photos .upload-product-photo').height(height);
      }), 100);
    }

    if ($('#uploaded_photos .fields input.main-photo-r[type=radio]:checked').length === 0) {
      const first_radio_box = $('input.main-photo-r[type=radio]').first();
      first_radio_box.prop("checked", true);
      return first_radio_box.closest('li').addClass('main-photo');
    }
  },

  _setMainPhoto(e) {
    let $target = $(e.target);

    if ($target.hasClass('text')) {
      $target = $target.parent();
    }

    $('.main-photo').removeClass('main-photo');
    $('input.main-photo-r[type=radio]').prop("checked", false);
    $target.closest('li').addClass('main-photo');
    return $target.siblings("input.main-photo-r").prop("checked", true);
  },

  _onPhotoDelete(e) {
    let new_value;
    const li = $(e.target).closest('li');
    if (li.hasClass('uploaded')) {
      li.data('photoid');
      new_value = $('#delete_photo_ids').val() + ',' + li.data('photoid');
      $('#delete_photo_ids').val(new_value);
    } else {
      new_value = $('#delete_photo_names').val() + ',' + li.data('filename');
      $('#delete_photo_names').val(new_value);
    }
    $('.dropper .deleted_photos').append(li.contents());
    li.remove();
    if ($('#uploaded_photos li.product-photo').length < 5) {
      if ($('.uploaded-photo-placeholder').length === 0) {
        setTimeout((function () {
          $('.dropper a.add_nested_fields').click();
          const height = $('#uploaded_photos li .photo-container').width();
          $('li.product-photo .photo-container img').css('max-height', height);
          $('li.product-photo .photo-container').height(height);
          return $('#uploaded_photos .upload-product-photo').height(height);
        }), 100);
      }
    }
    return false;
  },

  _initializeAddPhotosButton() {
    if ($('form.edit_project, form#new_project').length > 0) {
      const numberOfPhotos = $('#uploaded_photos li.product-photo').length;
      if ((numberOfPhotos > 0) && (numberOfPhotos < 5)) {
        return $('#upload-photos-form-content a.add_nested_fields').click();
      }
    }
  },

  _closeErrorModal(e) {
    return closeModal('exceed_maximum_number_of_photos');
  },

  _onBudgetChange(e) {
    const budget = this._fixBudgetAmount($(e.currentTarget).val());
    if (budget === "NaN") {
      return $(e.currentTarget).val(0);
    } else {
      return $(e.currentTarget).val(budget);
    }
  },

  _fixBudgetAmount(e) {
    const a = parseFloat(e.replace(/,/g, ''));
    return a.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  },

  _escapeEnterButton(e) {
    if (e.keyCode === 13) {
      return e.preventDefault();
    }
  },

  _activateButton(e) {
    if (e.keyCode !== 13) {
      return $(e.target).toggleClass('not-blank', ($.isNumeric($(e.target).val().split(',')[0]) && $.isNumeric($(e.target).val().split(',')[1])) || ($(e.target).val() !== ''));
    }
  },

  _initializeWorkplaceDropdown() {
    return $('.create-project-type-option').on('click', function () {
      $('.create-project-type-option').removeClass('selected');
      $(this).addClass('selected');
      $('#selected-create-project-type-option').html($(this).html());
      if ($(this).data('collection') === 'tenders') {
        $('#create-project-or-tender-button').attr('href', 'javascript:void(0)');
        $('#create-project-or-tender-button').on('click', () => $('#create-tender').foundation('reveal', 'open'));
        $('#create-project-or-tender-button').html('Create');
        $('#user-list-current-user, #project-filters-label').text(I18n.t('v4.projects.index.my_tenders'));
        $('#custom-filters .all-users span').text(I18n.t('v4.projects.index.all_tenders'));
        $('ul.sort li:last-child').removeClass('hide');
      }
      if ($(this).data('collection') === 'projects') {
        $('#create-project-or-tender-button').unbind('click');
        $('#create-project-or-tender-button').attr('href', '/workplace/projects/new');
        $('#create-project-or-tender-button').html('Create');
        $('#user-list-current-user, #project-filters-label').text(I18n.t('v4.projects.index.my_projects'));
        $('#custom-filters .all-users span').text(I18n.t('v4.projects.index.all_projects'));
        $('ul.sort li:last-child').addClass('hide');
      }
      $('a.user, a.filter, ul.sort a').removeClass('selected');
      $('ul.sort a[data-sort-column="date_updated"]').addClass('selected');
      $('ul.sort').prev().find('span').text(I18n.t('v4.projects.index.sorting_options.sort_by'));
      return $('#user-list-current-user').closest('a').addClass('selected');
    });
  },

  initializePublicForm() {
    MarkdownEditor.initialize('#project_description');
    $(document).on('click', '#project_location.not-blank + .search-btn', function (e) {
      e.preventDefault();
      google.maps.event.trigger($('#project_location')[0], 'focus');
      return google.maps.event.trigger($('#project_location')[0], 'keydown', { keyCode: 13 });
    });
    $.cloudinary.responsive();
    return this.initializeMap();
  },

  initializeMap() {
    const input = document.getElementById('project_location');
    this.address = new google.maps.places.Autocomplete(input);
    this.address.addListener('place_changed', _.bind(this._onLocationChange, this));
    this.geocoder = new google.maps.Geocoder();
    this.map = new google.maps.Map(document.getElementById('map'), { center: this._defaultLatLng, zoom: 8 });
    this.marker = new (google.maps.Marker)({ position: this._defaultLatLng, map: this.map, draggable: true });
    const geocoder = new google.maps.Geocoder();
    google.maps.event.addListener(this.marker, 'dragend', _.bind(this._onLocationMarkerChange, this));
    return google.maps.event.addDomListener(window, 'load', () => {
      if (input.value.match(/\S/)) {
        const request = { query: input.value };
        return geocoder.geocode({ 'address': input.value }, (results, status) => {
          return this.address.set('place', results[0]);
        });
      }
    });
  },

  initializeNewForm() {
    $('#project_construction_types, select[name="project[attribute_values][]"][multiple]:visible').selectize({ plugins: ['remove_button'] });
    $('body').on('change', '#project_budget_cents', _.bind(this._onBudgetChange, this));
    $('body').val(this._fixBudgetAmount($('#project_budget_cents').val()));
    $('#project_location').on('keypress', _.bind(this._escapeEnterButton, this));
    $('#project_location').on('keyup', _.bind(this._activateButton, this));
    $(document).on('click', '#project_location.not-blank + .search-btn', function (e) {
      e.preventDefault();
      google.maps.event.trigger($('#project_location')[0], 'focus');
      return google.maps.event.trigger($('#project_location')[0], 'keydown', { keyCode: 13 });
    });

    MarkdownEditor.initialize('#project_description');
    this.initializeMap();
    initializeProjectAttributes($('.project-attributes'));
    return $.cloudinary.responsive();
  },

  initializeProjectPhotoUpload() {
    $('#uploaded_photos').on('change', 'input[type=file]', _.bind(this._onPhotoInputChange, this));
    $('#uploaded_photos').on('click', 'a.set-as-cover-btn', _.bind(this._setMainPhoto, this));
    $('#uploaded_photos').on('click', 'a.delete-product-photo', _.bind(this._onPhotoDelete, this));
    $('#exceed_maximum_number_of_photos').on('click', 'a.button.small.pt-red.nobottommargin', _.bind(this._closeErrorModal, this));

    $(document).on('nested:fieldAdded', e => $(e.target).siblings('li:last').find('input[type=file]').addClass('hidden'));

    return this._initializeAddPhotosButton();
  },

  initializeProjectDestroyDialog() {
    return $(() => $(document).on('opened.fndtn.reveal', '#destroy_project_dialog[data-reveal]', function () {
      const toggleConfirmation = function () {
        const phasesChecked = $('.phase:checked').length !== 0;
        if (phasesChecked) {
          return $('#confirmation-alert').removeClass('hidden');
        } else {
          $('#confirmation-alert').addClass('hidden');
          $('#confirmation').prop('checked', false);
          return $('#tender_submit').prop('disabled', true);
        }
      };

      $('#remove_complete_project').change(function (e) {
        const checkboxes = $('#phases_removal input[type=checkbox]');
        const {
          checked
        } = e.target;
        checkboxes.prop('checked', checked);
        const closestTr = checkboxes.closest('tr');
        if (checked) { closestTr.addClass('selected'); } else { closestTr.removeClass('selected'); }
        return toggleConfirmation();
      });

      $('.phase').change(function () {
        $(this).closest('tr').toggleClass('selected');
        const allChecked = $('.phase').length === $('.phase:checked').length;
        $('#remove_complete_project').prop('checked', allChecked);
        return toggleConfirmation();
      });

      return $('#confirmation').change(function () {
        const btnDisabled = !$(this).prop('checked');
        return $('#tender_submit').prop('disabled', btnDisabled);
      });
    }));
  }
};
